
<template>
  <div class="room report-list" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command">
      <div class="table-command-item">
        <span>选择桥梁</span>
        <el-select v-model="bridgeId" placeholder="请选择桥梁">
          <el-option
            v-for="item in bridgeIdList"
            :key="item"
            :label="bridgeIdBridgeNameDict[item]"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="table-command-item">
        <span>接收编号</span>
        <el-input v-model="socketId" placeholder="请输入接收编号"></el-input>
      </div>
      <div class="table-command-item">
        <span>消息编号</span>
        <el-input v-model="messageId" placeholder="请输入消息编号"></el-input>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" :max-height="tableMaxHeight">
      <el-table-column align="center" label="接收编号(前8位)" prop="socketId"></el-table-column>
      <el-table-column align="center" label="消息编号(前8位)" prop="messageId"></el-table-column>
      <el-table-column align="center" label="版本号" prop="version"></el-table-column>
      <el-table-column align="center" label="数据时间" prop="dataDate"></el-table-column>
      <el-table-column align="center" label="接收时间" prop="createdDate"></el-table-column>
      <el-table-column align="center" label="ID" prop="id"></el-table-column>
      <el-table-column align="center" label="VALUE" prop="value"></el-table-column>
      <el-table-column align="center" label="桥梁" prop="bridgeName"></el-table-column>
      <el-table-column align="center" label="制备站" prop="stationName"></el-table-column>
      <el-table-column align="center" label="设备" prop="deviceName"></el-table-column>
      <el-table-column align="center" label="错误" prop="exceptionMessage"></el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      ref="page"
    ></el-pagination>
  </div>
</template>
<script>
import {
  assembleUrl,
  stringIsNullOrEmpty,
} from './../../tools/GeneralTool';

export default {
  name: 'UserControl',
  data() {
    return {
      loadingFullScreen: null,
      timer: null,
      isAdmin: false,
      tableData: [],
      fullDataList: null,
      bridgeIdBridgeNameDict: null,
      loading: false,
      shownewUser: false,
      checkUserId: '',
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      userTranslateDict: {},
      deviceNameReplaceList: ['状态', '(枚举)'],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
      showAllUser: false,
      bridgeId: '',
      socketId: '',
      messageId: '',
    };
  },
  computed: {
    bridgeIdList() {
      if (!this.bridgeIdBridgeNameDict) {
        return [];
      }

      return Object.keys(this.bridgeIdBridgeNameDict);
    },
  },
  created() {},
  mounted() {
    this.getData();

    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };

    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    console.log(this.$refs.room.clientWidth);
    console.log(this.$refs.page.$el.clientWidth);
    this.pageStyle = {
      left:
        (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 +
        'px',
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    bridgeId() {
      this.fullDataList = null;
      this.getData();
    },
    socketId() {
      this.fullDataList = null;
      this.getData();
    },
    messageId() {
      this.fullDataList = null;
      this.getData();
    },
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight =
        this.$refs.room.offsetHeight - this.paginationHeight;
    },
    createUserDialogVisible(newVal, oldVal) {
      if (newVal) {
        this.$refs.createUserForm.resetFields();
      }
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left:
            (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) /
              2 +
            'px',
        };
      });
    },
  },
  methods: {
    downloadImportTemplate() {
      window.open('/report/DownloadImportTemplate', '_blank');
    },
    refreshData() {
      this.getData();
    },
    currentChange(index) {
      this.currentPage = index;
      this.getData();
    },
    getData() {
      this.loading = true;

      let promiseList = [];
      if (this.bridgeIdBridgeNameDict === null) {
        promiseList.push(this.queryBridge());
      }
      if (this.fullDataList === null) {
        promiseList.push(this.queryFullData());
      }

      Promise.all(promiseList).then(() => {
        let startIndex = this.pageSize * (this.currentPage - 1);
        let endIndex = startIndex + this.pageSize;
        this.dataList = this.fullDataList.slice(startIndex, endIndex);

        this.tableData = this.dataList;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
    },
    async queryFullData() {
      let url = '/deviceData/socketList';
      let parameter = {};
      if (!stringIsNullOrEmpty(this.bridgeId)) {
        parameter['bridgeId'] = this.bridgeId;
      }
      if (!stringIsNullOrEmpty(this.messageId)) {
        parameter['messageId'] = this.messageId;
      }
      if (!stringIsNullOrEmpty(this.socketId)) {
        parameter['socketId'] = this.socketId;
      }
      url = assembleUrl(url, parameter);

      await this.$http.get(url).then((res) => {
        let dataList = res.data;
        dataList.forEach((dataItem) => {
          dataItem.socketId = dataItem.socketId.substr(0, 8);
          dataItem.messageId = dataItem.messageId.substr(0, 8);
        });

        this.fullDataList = dataList;
        this.totalCount = this.fullDataList.length;
      });
    },
    async queryBridge() {
      await this.$http.get('/bridge/bridgeList').then((res) => {
        this.bridgeIdBridgeNameDict = {};
        res.data.forEach((bridge) => {
          this.bridgeIdBridgeNameDict[bridge.bridgeId] = bridge.bridgeName;
        });
      });
    },
    async queryUser(userId) {
      await this.$http.get('/user/GetUserList?userId=' + userId).then((res) => {
        this.userTranslateDict[userId] = res.data[0].userName;
      });
    },
    async translateDataIdForDataList(
      refDataList,
      dataIdFieldName,
      translateResultFieldName,
      translateDictName,
      asyncQueryFunc
    ) {
      let idDict = {};
      refDataList.forEach((dataItem) => {
        if (dataItem[dataIdFieldName] !== undefined) {
          const dataKey = dataItem[dataIdFieldName];
          idDict[dataKey] = true;
        }
      });

      if (this[translateDictName] === undefined) {
        this[translateDictName] = {};
      }
      const translateDict = this[translateDictName];

      let queryPromiseList = [];
      for (let id in idDict) {
        if (translateDict[id] === undefined) {
          queryPromiseList.push(asyncQueryFunc(id));
        }
      }

      await Promise.all(queryPromiseList).then(() => {
        refDataList.forEach((dataItem) => {
          const dataKey = dataItem[dataIdFieldName];
          if (dataKey !== undefined) {
            const translateResult = translateDict[dataKey];
            dataItem[translateResultFieldName] = translateResult;
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.report-list {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;
  .table-command {
    display: flex;
    margin-bottom: 20px;

    .table-command-item {
      display: flex;

      span {
        width: 110px;
        margin-left: 20px;
        text-align: center;
        line-height: 40px;
        flex-shrink: 0;

        &:after {
          content: ':';
        }
      }

      ::v-deep .el-input__inner {
        width: 200px;
      }
    }
  }
  .pagination {
    position: absolute;
    bottom: 0;
  }
}
.status-tag {
  cursor: pointer;
}

::v-deep .el-pagination {
  text-align: center;
}
</style>
